"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZendeskScript;
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set-timeout"));
var _head = _interopRequireDefault(require("next/head"));
var _script = _interopRequireDefault(require("next/script"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Zendesk/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ZendeskScript(_ref) {
  let {
    tenant,
    apiKey,
    onError
  } = _ref;
  const {
    setWidgetType,
    setUnreadMessages
  } = (0, _react.useContext)(_index.ZendeskContext);
  function initialize() {
    try {
      var _window;
      if (!((_window = window) !== null && _window !== void 0 && _window.zE)) return;
      const widgetType = window.zE.widget;
      setWidgetType(widgetType);
      if (widgetType === 'messenger') {
        window.zE('messenger', 'hide');
        window.zE('messenger:set', 'locale', 'en');
        window.zE('messenger:set', 'zIndex', 21);
        window.zE('messenger:on', 'unreadMessages', function (count) {
          setUnreadMessages(count);
        });
        window.zE('messenger', 'show');
      } else if (widgetType === 'classic') {
        window.zE('webWidget', 'hide');
        window.zE('webWidget', 'updateSettings', {
          webWidget: {
            offset: {
              mobile: {
                vertical: '100px'
              }
            },
            zIndex: 10,
            ...(tenant === 'tk' ? {
              color: {
                theme: '#FF44CB',
                launcher: '#FF44CB',
                launcherText: '#fff',
                button: '#FF44CB',
                resultLists: '#000',
                header: '#FF44CB',
                articleLinks: '#FF44CB'
              }
            } : {})
          }
        });
        window.zE('webWidget', 'show');
      } else {
        /* eslint-disable-next-line no-console */
        console.warn('Widget type not recognized:', widgetType);
      }
    } catch (error) {
      onError(error);
    }
  }
  function pollScriptLoaded() {
    const checkInterval = 100;
    const timeoutId = (0, _setTimeout2.default)(function check() {
      var _window2;
      if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.zE) !== null && _window2 !== void 0 && _window2.widget) {
        clearTimeout(timeoutId);
        initialize();
      } else {
        (0, _setTimeout2.default)(check, checkInterval);
      }
    }, checkInterval);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "dns-prefetch",
    href: "https://static.zdassets.com"
  })), /*#__PURE__*/_react.default.createElement(_script.default, {
    id: "ze-snippet",
    "data-testid": "ze-snippet",
    defer: true,
    src: `https://static.zdassets.com/ekr/snippet.js?key=${apiKey}`,
    onLoad: pollScriptLoaded
  }));
}